export default __webpack_public_path__ + "static/media/640_business02-nl-web.01923961.png";